import { useNavigate } from "react-router-dom";
import { Map } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";

export function RoadmapLink({ className = "" }) {
  const navigate = useNavigate();
  const open = async () => {
    try {
      const { data } = await api.get("/ayuda/articles/by-key/roadmap-sofi2");
      navigate(`/app/ayuda?article=${data.id}`);
    } catch {
      toast.error("El roadmap solo está disponible para Dirección/Administración");
    }
  };
  return (
    <Button variant="outline" size="sm" onClick={open} className={className} data-testid="ver-roadmap-btn">
      <Map className="mr-1.5 h-4 w-4" />Ver roadmap
    </Button>
  );
}
